import Images from "../../utils/Images";

export default function AboutHero() {
  const fallbackImage =
    "https://images.unsplash.com/photo-1551861568-b87304b12bf4?q=80&w=1470&auto=format&fit=crop&ixlib=rb-4.0.3";

  return (
    <section className="pt-20 relative w-full min-h-[380px] md:min-h-[440px] lg:min-h-[520px] overflow-hidden">
      <img
        src={Images.about_hero || fallbackImage}
        alt="TripSecure About Hero"
        className="object-cover absolute inset-0 w-full h-full"
      />
      {/* Layered, modern overlays */}
      <div className="absolute inset-0 bg-gradient-to-r to-transparent from-black/80 via-black/60" />
      <div className="absolute inset-0 bg-gradient-to-b via-transparent from-black/20 to-black/70" />
      <div className="absolute -left-24 -top-24 w-[420px] h-[420px] rounded-full blur-3xl opacity-30 bg-emerald-500/40" />
      <div className="absolute -right-32 bottom-0 w-[420px] h-[420px] rounded-full blur-3xl opacity-20 bg-emerald-300/30" />

      <div className="relative z-10 px-6 py-16 mx-auto max-w-6xl md:py-24 lg:py-28">
        {/* Badge */}
        <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-white/10 border border-white/15 backdrop-blur text-white/80 text-xs">
          <span className="w-1.5 h-1.5 rounded-full bg-emerald-400 animate-pulse" />
          Africa's Leading Travel Safety Platform
        </div>

        <h1 className="mt-4 text-3xl font-extrabold leading-tight text-white md:text-4xl lg:text-5xl">
          Travel Smart. Stay Safe.
          <br className="hidden md:block" />
          <span className="inline-block relative text-transparent bg-clip-text bg-gradient-to-r from-emerald-400 to-emerald-200">
            Ride Secured.
            <span className="absolute left-0 bottom-1 h-1 w-full rounded-full bg-emerald-400/20 blur-[2px]" />
          </span>
        </h1>

        <p className="mt-4 max-w-3xl text-[13px] md:text-sm lg:text-base text-white/85">
          At TripSecure, we're redefining how Africa travels — combining insurance, tourism, logistics, and safety into one seamless digital experience. Whether you're booking a flight, joining a group tour, sending a parcel, or simply moving from one city to another, TripSecure gives you the confidence and protection you deserve.
        </p>

        {/* Quick stats */}
        <div className="grid grid-cols-2 gap-3 mt-8 max-w-xl sm:grid-cols-3">
          {[
            { label: "Policies Issued", value: "100k+" },
            { label: "Insurance Partners", value: "300+" },
            { label: "Claims Paid", value: "GHS 1M+" },
          ].map((s) => (
            <div
              key={s.label}
              className="px-4 py-3 rounded-xl border backdrop-blur-sm border-white/10 bg-white/10 text-white/90"
            >
              <div className="text-lg font-bold text-emerald-300">{s.value}</div>
              <div className="text-[11px] md:text-xs text-white/80">{s.label}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}


